// tslint:disable
export enum AccountType {
    /**
     * @description PATIENT
     */
    PATIENT = 1,
    /**
     * @description PRESCRIBER
     */
    PRESCRIBER = 2,
    /**
     * @description SITE
     */
    SITE = 3,
}
